'use client';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { SvgIcon } from '@s7/base';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const NewSlimHomeLinear = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ jsxs(SvgIcon, _extends({
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props, {
        ref: ref,
        children: [
            /*#__PURE__*/ jsx("path", {
                fill: "currentColor",
                d: "M5.3 10.25h5.4a.45.45 0 0 1 0 .9H5.3a.45.45 0 1 1 0-.9"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M12.974 5 9.638 2.534a2.78 2.78 0 0 0-3.276 0L3.032 5A2.48 2.48 0 0 0 2 7.004v4.458a2.604 2.604 0 0 0 2.664 2.537h6.672A2.604 2.604 0 0 0 14 11.461V6.998A2.49 2.49 0 0 0 12.974 5m.126 6.461a1.704 1.704 0 0 1-1.764 1.638H4.664A1.71 1.71 0 0 1 2.9 11.461V7.004c.003-.51.25-.988.666-1.284l3.33-2.46c.658-.48 1.55-.48 2.208 0l3.33 2.466c.415.291.663.765.666 1.272z",
                clipRule: "evenodd"
            })
        ]
    })));

export { NewSlimHomeLinear, NewSlimHomeLinear as default };
//# sourceMappingURL=NewSlimHomeLinear.js.map
